/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import DescriptionTable from "./DescriptionTable";
import TypesOfRisks from "pages/StepPages/StepFour/One/Tables/TableNavigate/TypesOfRisksTable";
import ObjectsOfImpactTable from "pages/StepPages/StepFour/One/Tables/TableNavigate/ObjectsOfImpactTable";
import CollusionGroupsTable from "pages/StepPages/StepFour/One/Tables/TableNavigate/CollusionGroupsTable";
import AssessmentObjectives from "pages/StepPages/StepFour/One/Tables/TableNavigate/AssessmentOfObjectivesTable";
import LevelsOfVariantsTable from "pages/StepPages/StepFour/One/Tables/TableNavigate/LevelsOfVariantsTable";
import CurrentViolatorsTable from "pages/StepPages/StepFour/One/Tables/TableNavigate/CurrentViolatorsTable";
import PossibleObjectsTable from "pages/StepPages/StepFour/One/Tables/TableNavigate/PossibleObjectsTable";
import ListOfBasicTable from "pages/StepPages/StepFour/One/Tables/TableNavigate/ListOfBasicTable";
import ListCurrentThreatsTable from "pages/StepPages/StepFour/One/Tables/TableNavigate/ListCurrentThreatsTable";

export const componentsList = {
	description: DescriptionTable,
	types_of_risks: TypesOfRisks,
	objects_of_impact: ObjectsOfImpactTable,
	collusion_groups: CollusionGroupsTable,
	assessment_of_objectives: AssessmentObjectives,
	levels_of_violators: LevelsOfVariantsTable,
	current_violators: CurrentViolatorsTable,
	possible_objects: PossibleObjectsTable,
	list_of_basic: ListOfBasicTable,
	list_current_threats: ListCurrentThreatsTable,
};
